import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Category';
import create from './create';
import edit from './edit';
import list from './list';

const awards: ResourceProps = {
  name: 'utility-categories',
  icon,
  options: { label: 'Categorias' },
  create,
  edit,
  list
};

export default awards;
